import { IWebSDKCountryCodes } from '@sxm-de/dev-kits/web-sdk/types';
import { AdobeAppEventDataSdk } from './adobe/app-event-data';
import { bootstrapClientSdk } from './clientsdk/bootstrap-clientsdk';
import { SentryConfig } from './clientsdk/observability/types-sentry';
import { IWebSDK, IWebSDKApplicationUrls, IWebSDKThirdParty } from './types';
import { WebSDK } from './web-sdk';
import { bootstrapSentry } from './sentry/bootstrap-sentry';
import { CookieManager } from '@sxm-web/cookie-manager';
import { getDomainForCookie } from '@sxm-de/dev-kits/web-sdk/utils';

export async function bootstrapWebSdk({
    clientSdkConfig,
    sentry,
    microservices,
    appUrls,
    countryCode,
    locale,
    featureFlags,
    thirdParty,
}: {
    clientSdkConfig: {
        baseUrl: string;
        baseUrlMicroservices?: string;
        baseUrlMicroservicesCanada?: string;
        baseUrlContentful?: string;
        paymentPlatformApiKey: string;
        paymentPlatformSdkUrl: string;
        contentfulSpaceId?: string;
        contentfulEnvironmentId?: string;
        contentfulAccessToken?: string;
        baseUrlCDN: string;
    };
    sentry: SentryConfig;
    microservices: {
        baseUrlUS: string;
        baseUrlCanada: string;
    };
    appUrls: IWebSDKApplicationUrls;
    countryCode: IWebSDKCountryCodes;
    locale: {
        languages: {
            supported: ('en-CA' | 'en-US' | 'fr-CA')[];
            default: 'en-CA' | 'en-US' | 'fr-CA';
        };
    };
    featureFlags: Record<string, boolean>;
    thirdParty: IWebSDKThirdParty;
}): Promise<IWebSDK> {
    if (sentry.enabled) {
        bootstrapSentry(sentry);
    }
    /**
     * TODO:
     * Come up with a plan for how we can use Sentry (if enabled) throughout WebSdk and possibly other Sdks
     * to handle logging.
     */

    const domain = getDomainForCookie();
    const clientSdkStorageProvider = new CookieManager({
        cookieOptionOverrides: {
            AUTH_TOKEN: { domain, path: '/' },
            'SXM-CLOCK': { domain, path: '/' },
        },
    });
    const clientSdk = await bootstrapClientSdk({
        baseUrl: clientSdkConfig.baseUrl,
        sentry,
        clientSdkStorageProvider,
    });

    const webSdk = new WebSDK();
    webSdk.init({
        initDependencies: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            clientSdk: clientSdk as any,
            appEventSdk: AdobeAppEventDataSdk.instance,
            clientSdkStorageProvider,
        },
        settings: {
            microservices,
            appUrls,
            countryCode,
            locale: locale.languages,
            featureFlags,
            clientSdkConfig,
            thirdParty,
        },
    });
    return webSdk;
}
